import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '@services/auth';

// 创建上下文
const AuthContext = createContext(null);

// 创建自定义 Hook
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// 认证提供者组件
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 系统登录
  const login = async (username, password) => {
    const result = await authService.login(username, password);
    if (result.success) {
      setUser(result.data);
    }
    return result;
  };

  // 登出
  const logout = async () => {
    try {
      const result = await authService.logout();
      if (result.success) {
        setUser(null);
        // 强制刷新页面，确保所有状态都被清理
        window.location.href = '/';
      }
      return result;
    } catch (error) {
      console.error('Logout error:', error);
      return { success: false, message: error.message || '登出失败' };
    }
  };

  // 修改密码
  const changePassword = async (oldPassword, newPassword) => {
    return await authService.changePassword(oldPassword, newPassword);
  };

  // 检查登录状态
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // 如果本地存储中没有用户信息，直接设置 loading 为 false
        const userInfo = localStorage.getItem('user_info');
        if (!userInfo) {
          setLoading(false);
          return;
        }

        // 检查令牌是否过期
        const token = localStorage.getItem('access_token');
        if (!token) {
          setLoading(false);
          return;
        }

        const userInfoData = await authService.getUserInfo();
        if (userInfoData) {
          setUser(userInfoData);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Check auth error:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const value = {
    user,
    loading,
    login,
    logout,
    changePassword
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 